import React from 'react';
import { Modal } from '@gerdau/hefesto/';
import { ModalText } from './style';

const ProductCartModal = ({
  openModal,
  handleModalAction
}: {
  openModal: boolean;
  handleModalAction: (withDelete?: boolean) => void;
}) => {
  if (!openModal) {
    return null;
  }

  return (
    <Modal
      buttons={{
        left: {
          children: 'Manter',
          name: 'cancel-delete',
          type: 'button',
          variant: 'secondary',
          onClick: () => handleModalAction()
        },
        right: {
          children: 'Excluir itens selecionados',
          name: 'detele',
          type: 'button',
          variant: 'danger',
          onClick: () => handleModalAction(true)
        }
      }}
      modalSize="md"
      title="Excluir itens selecionados"
    >
      <ModalText>
        Tem certeza que deseja excluir todos os itens selecionados do carrinho?
      </ModalText>
    </Modal>
  );
};

export default ProductCartModal;
